import { TabulatedChipButtonGroupBudget } from 'routes/BudgetModule/components/shared/TabulatedChipButtonGroup/TabulatedChipButtonGroupBudget';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyBackgroundLessTabulatedChip = styled(
    TabulatedChipButtonGroupBudget,
    {
        name: 'StyBackgroundLessTabulatedChip',
    },
)(({ theme }) => ({
    '& #tabulated-chip-button-group-header': {
        paddingLeft: 0,
        backgroundColor: 'transparent',
        '& > .MuiTabs-root': {
            marginLeft: 0,
        },
        '& .MuiToggleButton-root': {
            border: 'none',
            backgroundColor: 'transparent',
            '&.Mui-selected': {
                backgroundColor: theme.palette.primary.main,
            },
            '&.Mui-disabled .MuiTypography-body1SemiBold': {
                color: `${theme.palette.grey[500]} !important`,
            },
        },
    },
}));

export const StyHRPage = styled(Box)(({ theme }) => ({
    backgroundColor: 'transparent',
    '&.MuiToggleButton-root, .Mui-disabled': {
        backgroundColor: 'transparent ',
        border: 'none',
    },
    '.Mui-disabled body1SemiBold': {
        color: `${theme.palette.grey[500]} !important`,
    },
    '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
    },
}));
